import './ErrorModal.scss';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useBoundAction } from 'src/hooks/useBoundAction';
import { Button } from 'src/modules/common/components/Button';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import {
  MODAL_ORGANIZATION_ERROR_CLOSE,
  MODAL_ORGANIZATION_ERROR_RETRY,
} from 'src/modules/modals/actions/ModalActions';
import { ModalWindowOrganizationError } from 'src/modules/modals/types/ModalWindow';

type Props = {
  readonly modal: ModalWindowOrganizationError;
};

export const OrganizationErrorModal = ({ modal }: Props): React.ReactElement => {
  const intl = useIntl();
  const closeModal = useBoundAction(MODAL_ORGANIZATION_ERROR_CLOSE.trigger);
  const retry = useBoundAction(MODAL_ORGANIZATION_ERROR_RETRY.request, modal.data);

  const loading = modal.status?.state === 'pending';

  return (
    <div className="bp-error-modal">
      <ModalHeader
        title={<FormattedMessage id="organizationErrorModal/title"/>}
      />

      <ModalBody>
        <div className="bp-error-modal__body">
          <h2 className="bp-error-modal__body-title">
            <FormattedMessage id="organizationErrorModal/subtitle"/>
          </h2>

          <p className="bp-error-modal__body-description">
            <FormattedMessage id="organizationErrorModal/description"/>
          </p>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          kind="secondary"
          fullWidth={true}
          onClick={closeModal}
          disabled={loading}
        >
          <FormattedMessage id="organizationErrorModal/close"/>
        </Button>

        <Button
          disabled={loading}
          kind="primary"
          fullWidth={true}
          onClick={retry}
          autoFocus={true}
          loading={loading}
        >
          <FormattedMessage id="organizationErrorModal/retry"/>
        </Button>
      </ModalFooter>
    </div>
  );
};
